import WikiArticleList from "./WikiArticleList";

import "./WikiArticleList.scss";

export * from "./WikiArticleList.types";

export { WikiArticleList };
